<i18n>
{
  "fr": {
  },
  "en": {

  }
}
</i18n>

<template>
  <div></div>
</template>

<script>
export default {
  name: 'FiltersEntity'
}
</script>
